import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.timers.js";
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";

import { useEventBus } from '@vueuse/core';
import { reactive, ref, computed, nextTick } from 'vue';
var _hoisted_1 = {
  "class": "leading-[1.4]"
};
var _hoisted_2 = {
  key: 1,
  "class": "PBSnackbar__line"
};
export default {
  __name: 'PBSnackbar',
  setup: function setup(__props) {
    var notifyBus = useEventBus("notify");
    var props = reactive({
      type: "error",
      text: "",
      delay: 6000,
      customAction: null,
      persistent: false,
      showCloseIcon: true
    });
    var isOpened = ref(false);
    var icon = computed(function () {
      if (props.type === "error") {
        return "warning";
      }
      if (props.type === "info") {
        return "info";
      }
      return "check";
    });
    var timeout;
    function close() {
      isOpened.value = false;
    }
    function runCustomAction() {
      if (props.customAction) {
        props.customAction();
        close();
      }
    }
    notifyBus.on( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var _payload$type, _payload$delay;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              clearTimeout(timeout);
              close();
              _context.next = 4;
              return nextTick();
            case 4:
              props.text = payload.text;
              props.type = (_payload$type = payload.type) !== null && _payload$type !== void 0 ? _payload$type : "error";
              props.customAction = payload.customAction;
              props.persistent = payload.persistent;
              props.delay = (_payload$delay = payload.delay) !== null && _payload$delay !== void 0 ? _payload$delay : 6000;
              props.showCloseIcon = payload.showCloseIcon === undefined ? true : payload.showCloseIcon;
              isOpened.value = true;
              if (!props.persistent) {
                timeout = setTimeout(function () {
                  return isOpened.value = false;
                }, props.delay);
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      return _unref(isOpened) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "PBSnackbar border border-solid border-t-zinc-700 border-x-zinc-700/80 border-b-zinc-700/60 fixed z-[200000] bottom-[32px] left-1/2 max-w-[600px] -translate-x-1/2 flex items-center py-lg px-xl bg-background text-white rounded-md overflow-hidden shadow-lg transition-all",
        onClick: _withModifiers(runCustomAction, ["stop"])
      }, [_createVNode(_component_PBIcon, {
        name: _unref(icon),
        w: 20,
        h: 20,
        "class": _normalizeClass(["mr-xl min-w-[24px]", {
          'text-danger': _unref(props).type === 'error',
          'text-success': _unref(props).type === 'success',
          'text-primary': _unref(props).type === 'info'
        }])
      }, null, 8, ["name", "class"]), _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(props).text), 1), _unref(props).showCloseIcon ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "class": "PBSnackbar__close border border-solid border-zinc-700 rounded-md flex items-center justify-center min-w-[32px] ml-xl min-h-[32px] hover:bg-zinc-700 transition-colors",
        onClick: _withModifiers(close, ["prevent", "stop"])
      }, [_createVNode(_component_PBIcon, {
        name: "close",
        w: 10,
        h: 10
      })])) : _createCommentVNode("", true), !_unref(props).persistent && _unref(isOpened) ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};